import { useEffect, useRef } from 'react'
import useMediaQuery from 'hooks/use-media-query'
import { credencialesVideo } from '../constants'
import useNearViewport from '../hooks/use-near-viewport'

// Full-width key visual loop (Figma desktop 5631:1848 1920x840, mobile
// 5863:3789 374x164), no padding between the process and the gallery. The
// source is attached only when the section approaches the viewport.
const KvSection = () => {
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const sectionRef = useRef<HTMLElement>(null)
  const videoRef = useRef<HTMLVideoElement>(null)
  const near = useNearViewport(sectionRef)
  const src = credencialesVideo(isDesktop ? 'vid_hnk_horizontal_desktop.mp4' : 'vid_hnk_horizontal_mobile.mp4')

  useEffect(() => {
    const video = videoRef.current
    if (!video || !near) return
    video.muted = true
    video.setAttribute('muted', '')
    video.play().catch(() => undefined)
  }, [src, near])

  return (
    <section ref={sectionRef} className="credenciales__kv">
      <video
        ref={videoRef}
        key={src}
        className="credenciales__kv-video"
        src={near ? src : undefined}
        autoPlay
        muted
        loop
        playsInline
        preload={near ? 'metadata' : 'none'}
      />
    </section>
  )
}

export default KvSection
